/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var IllustratorIcon = createIcon("IllustratorIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.704 34 1.82-5.082h7.756L26.086 34h3.416l-7.266-20.244H18.54L11.274 34h3.43Zm8.722-8.106h-6.09l3.052-8.834 3.038 8.834ZM35.76 16.99v-3.22h-3.374v3.22h3.374ZM35.704 34V19.524h-3.262V34h3.262Z",
    fill: "#FF9A00"
  }));
}, {
  "i18nKey": "svg.IllustratorIcon"
});